import React, { useContext } from 'react'
import EnvInput from 'app/React/Components/EnvInput'
import Spinner from "react-components/Components/Spinner";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function TradeFields({ displayGuaranteePrice, loading, onEnvInputBlur, message }) {
  const { strings } = useContext(ConfiguratorContext)

  const paymentFormStrings = strings.payment_form ?? {}

  return (
    <>
      <div className='config-form__separator-transparent'/>
      <div className='config-form__inputs'>
        <div className='config-form__input config-form__input--half'>
          <label className='config-form__input-label'>{paymentFormStrings.trade.plate}</label>
          <EnvInput name='trade_plate' onBlur={onEnvInputBlur} readOnly={loading}/>
          {loading ? <Spinner/> : null}
        </div>

        <div className='config-form__input config-form__input--half'>
          <label className='config-form__input-label'>{paymentFormStrings.trade.km}</label>
          <EnvInput type='number' name='trade_km' onBlur={onEnvInputBlur} readOnly={loading}/>
          {loading ? <Spinner/> : null}
        </div>

        {
          displayGuaranteePrice && (
            <div className='config-form__input'>
              <label className='config-form__input-label'>{paymentFormStrings.trade.outstanding_debt}</label>
              <EnvInput type='number' name='guarantee_price_outstanding_debt'/>
            </div>
          )
        }

        {typeof paymentFormStrings.guarantee_price?.outstandingDebtNotice === 'string' && paymentFormStrings.guarantee_price?.outstandingDebtNotice.length > 0 && (
          <div className='config-form__description' style={{ marginTop: '-16px' }}>
            <p>{paymentFormStrings.guarantee_price?.outstandingDebtNotice}</p>
          </div>
        )}

        {loading && (<div>{paymentFormStrings.guarantee_price?.loadingMessage}</div>)}
        {message && (<div>{message}</div>)}
      </div>
    </>
  )
}
